export default {
  common: {
    welcome: 'Welcome',
    language: 'Language',
    switchLanguage: 'Language switched successfully',
    chinese: 'Chinese',
    english: 'English',
    logout: 'Sign Out',
    myOrder: 'My Orders',
    confirmLogout: 'Are you sure you want to sign out?',
    logoutSuccess: 'Signed out successfully',
    remainingTimes: 'Remaining',
    times: 'times',
    unlimited: 'Unlimited',
    confirm: 'Confirm',
    cancel: 'Cancel',
    companyName: 'North America Unlimited Inc.',
    tip: 'Notice',
    copySuccess: 'Copied successfully',
    copyFailed: 'Failed to copy',
    loading: 'Loading...'
  },
  button: {
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search'
  },
  message: {
    success: 'Operation successful',
    error: 'Operation failed',
    loading: 'Loading...',
    noData: 'No data available'
  },
  nav: {
    home: 'Home',
    about: 'About',
    contact: 'Contact Us'
  },
  login: {
    title: 'Please select login method',
    merchantLogin: 'Merchant',
    bloggerLogin: 'Blogger',
    photographerLogin: 'Photographer',
    advertiserLogin: 'Advertiser',
    accountPlaceholder: 'Enter your account',
    passwordPlaceholder: 'Enter your password',
    loginButton: 'Sign In',
    loginSuccess: 'Signed in successfully',
    loginFailed: 'Sign in failed. Please check your credentials',
    fillAccountPassword: 'Please enter your account and password'
  },
  menu: {
    aiCreation: 'AI Creation',
    draftReview: 'Draft Review & Feedback',
    publishManagement: 'Publishing',
    purchasePackage: 'Packages'
  },
  aiCreation: {
    generateContent: 'Generate Content',
    inputContent: 'Input',
    inputPlaceholder: 'Describe what you want to create...',
    startDesign: 'Generate',
    recreate: 'Recreate',
    generateResult: 'Result',
    article: 'Article',
    image: 'Image',
    video: 'Video',
    noTask: 'No Tasks',
    noTaskDesc: 'No tasks available at the moment. Please check back later.',
    generating: 'Generating...',
    completed: 'Completed',
    download: 'Download',
    downloadSuccess: 'Downloaded successfully',
    noDownloadContent: 'No content available for download',
    ratio: 'Aspect Ratio',
    ratioRequired: 'Aspect Ratio*',
    duration: 'Duration',
    durationRequired: 'Duration*',
    uploadImage: 'Upload Image',
    uploadVideo: 'Upload Reference Video',
    inputTag: 'Add tag',
    disclaimer: 'This content is generated by AI technology and does not represent the platform\'s views. It is provided for reference only and does not constitute legal advice. No warranties are made regarding its accuracy, completeness, or reliability.',
    previewImage: 'Preview Image',
    preview: 'Preview',
    delete: 'Delete',
    createFailed: 'Failed to create task, please try again later',
    detailFailed: 'Failed to get task details, please try again later',
    generationFailed: 'Generation Failed',
    generationFailedDesc: 'Please try again. Failed generations do not consume your usage count',
    retryGeneration: 'Please try again from the left panel',
    copy: 'Copy',
    copySuccess: 'Copied successfully',
    copyFailed: 'Failed to copy',
    noCopyContent: 'No content available to copy',
    historyRecord: 'History',
    backToCurrent: 'Back',
    noHistory: 'No history records',
    textToVideo: 'Text to Video',
    imageToVideo: 'Image to Video',
    videoToVideo: 'Video to Video',
    resetSuccess: 'Reset successfully, you can create again',
    noDescription: 'No description',
    noContent: 'No content',
    imageUploadSuccess: 'Image uploaded successfully',
    imageUploadFailed: 'Failed to upload image',
    videoUploadSuccess: 'Video uploaded successfully',
    videoUploadFailed: 'Failed to upload video',
    imageDeleteSuccess: 'Image deleted successfully',
    pleaseInputText: 'Please enter prompt text',
    pleaseUploadImage: 'Please upload reference image',
    pleaseSelectRatio: 'Please select aspect ratio',
    pleaseSelectDuration: 'Please select duration',
    pleaseUploadVideo: 'Please upload reference video',
    taskGenerating: 'Task is generating, please try again later',
    translating: 'Translating...',
    getHistoryFailed: 'Failed to get history records',
    switchTypeConfirm: 'Switching type will clear current content. Continue?',
    videoLoadFailed: 'Video failed to load. Please check your network or try again later'
  },
  review: {
    pending: 'Pending Review',
    passed: 'Approved',
    rejected: 'Rejected',
    pendingTab: 'Pending',
    passedTab: 'Approved',
    rejectedTab: 'Rejected',
    packageName: 'Package',
    linkId: 'Link ID',
    draftSource: 'Source',
    publishPlatform: 'Platform',
    title: 'Title',
    content: 'Content',
    pusher: 'Submitted By',
    pushTime: 'Submitted At',
    reviewStatus: 'Status',
    operation: 'Actions',
    review: 'Review',
    view: 'View',
    reviewDetail: 'Review Details',
    type: 'Type',
    historyReview: 'Review History',
    reviewResult: 'Result',
    reviewTime: 'Reviewed At',
    reviewOpinion: 'Comments',
    reviewPass: 'Approve',
    reviewReject: 'Reject',
    inputReviewOpinion: 'Enter your review comments',
    reviewSuccess: 'Review submitted successfully',
    reviewFailed: 'Review submission failed',
    pass: 'Approved',
    reject: 'Rejected'
  },
  publish: {
    totalCount: 'Total',
    waitingCount: 'Pending',
    publishedCount: 'Published',
    remainingCount: 'Remaining',
    selectPackage: 'Select a package',
    publishLink: 'Link',
    publisher: 'Publisher',
    publishTime: 'Published At',
    copyContent: 'Copy',
    copyLink: 'Copy Link',
    linkCopied: 'Copied to clipboard',
    copyFail: 'Failed to copy',
    noLink: 'No link available',
    noData: 'No data available'
  },
  purchase: {
    packageList: 'Available Packages',
    orderNow: 'Subscribe',
    agreeService: 'By purchasing, you agree to our',
    serviceAgreement: 'Terms of Service',
    pleaseAgreeService: 'Please agree to the Terms of Service first',
    paymentMethod: 'Payment Method',
    crossBankTransfer: 'Bank Transfer',
    paidAndSent: 'I have completed payment',
    tip: 'Payment Instructions',
    sendScreenshotTo: 'Please send payment confirmation to:',
    wechatId: 'WeChat ID:',
    singlePackage: 'One-time',
    monthlyPackage: '1 Month',
    threeMonthPackage: '3 Months',
    unlimitedPackage: 'Unlimited',
    insPost: 'Instagram posts',
    youtubePost: 'YouTube posts',
    facebookPost: 'Facebook posts',
    aiCreation: 'AI generations',
    unlimited: 'Unlimited',
    times: 'times',
    friendlyReminder: 'Payment Verification Reminder',
    paymentConfirmMessage: 'Please send your payment confirmation screenshot to the designated email. Our team will review your payment details and follow up shortly. Thank you.',
    iUnderstand: 'Got it'
  },
  order: {
    orderList: 'Orders',
    orderNo: 'Order #',
    packageName: 'Package',
    packageContent: 'Details',
    purchaseTime: 'Purchased',
    orderStatus: 'Status',
    payTime: 'Paid',
    pending: 'Pending Payment',
    paid: 'Paid',
    completed: 'Completed',
    cancelled: 'Cancelled',
    orderDetail: 'Order Details',
    orderAmount: 'Amount',
    orderTime: 'Order Date',
    unpaid: 'Not paid',
    paymentSuccess: 'Payment successful',
    callbackFailed: 'Payment verification failed',
    orderListFailed: 'Failed to load orders',
    searchOrderNo: 'Search by order number'
  }
}
